import React, {useState, useEffect, useRef} from 'react';
import {motion} from 'framer-motion';
import {Container} from 'react-bootstrap';
import {Link} from "react-router-dom";

import Logo from './Logo';
import SocialMedia from './SocialMedia';
import ChatComponent from './ChatComponent';
import {useLanguage} from './LanguageProvider';

import backgroundImg from '../images/bg20.png';

function Home() {

    const {language} = useLanguage();

    return (
        <div style={{paddingRight: '1rem'}}>
            <div style={{
                position: 'fixed',
                left: '0',
                top: '0',
                backgroundColor: 'black',
                background: 'linear-gradient(to bottom, black 70%, rgba(0,0,0,0.5) 100%)',
                width: '100%',
                height: '10rem',
                zIndex: '2'
            }}>


            </div>

            <Container>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 0.4 } }}
                    exit={{ opacity: 0, transition: { duration: 0.25 } }}
                >

                    <div className='cont-header' style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 3rem'
                    }}>
                        <Logo/>


                        <SocialMedia/>
                    </div>


                    <div style={{position: 'fixed', inset: 0, zIndex: '0', overflow: 'hidden'}}>
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center',
                                filter: 'brightness(50%)'
                            }}
                            src={backgroundImg} alt=''/>
                    </div>


                    <div style={{
                        zIndex: '50',
                        textAlign: 'center',
                        marginTop: '12rem',
                        marginBottom: '5rem',
                        position: 'relative'
                    }}>
                        <div style={{
                            fontSize: '3.8rem',
                            color: 'white',
                            fontWeight: '300',
                            textShadow: '3px 3px 5px rgb(137, 110, 82)'
                        }}>
                            {language === 'en' ?
                                <>Real estate in the heart of Kyiv</>
                                :
                                <>Нерухомість у самому серці Києва</>
                            }

                        </div>
                        <div style={{
                            marginTop: '2rem',
                            fontSize: '2.1rem',
                            color: '#dfdfdf',
                            fontWeight: '300',
                            textShadow: '3px 3px 5px rgb(137, 110, 82)'
                        }}>
                            {language === 'en' ?
                                'Discover the ease and comfort of finding the perfect home with us!'
                                :
                                'Відкрийте для себе легкість та комфорт у пошуку ідеального житла разом з нами!'
                            }
                        </div>
                    </div>

                    <div className="buy-rent-block">
                        <Link
                            to="/buy"
                            className="planet-text-img">
                            {language === 'en' ? 'Buy' : 'Продаж'}
                        </Link>
                        <Link
                            to="/rent"
                            className="planet-text-img">
                            {language === 'en' ? 'Rent' : 'Оренда'}
                        </Link>
                    </div>

                </motion.div>

            </Container>

            <div style={{
                position: 'fixed',
                left: '0',
                bottom: '0',
                backgroundColor: 'black',
                background: 'linear-gradient(to top, black 50%, rgba(0,0,0,0.4) 100%)',
                width: '100%',
                height: '4rem',
                zIndex: '2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>

            </div>
        </div>

    );
}

export default Home;
